import React from 'react'
import { LoaderDots } from '../'
import { OverlayWrapper } from './style'

const LoaderDotsWithOverlay = () => {
  return (
    <OverlayWrapper>
      <LoaderDots />
    </OverlayWrapper>
  )
}

export default LoaderDotsWithOverlay
